import { useState, useEffect } from "react";
import { doc, updateDoc, increment } from "firebase/firestore";
import { db } from "../firebase";

const STORAGE_KEY = "discoversvaneti_liked_places";

function getLikedPlaces() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function setLikedPlaces(ids) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // ignore
  }
}

export function useLike(placeId, initialLikes = 0) {
  const [liked, setLiked] = useState(false);
  const [count, setCount] = useState(initialLikes);

  useEffect(() => {
    const likedPlaces = getLikedPlaces();
    setLiked(likedPlaces.includes(placeId));
  }, [placeId]);

  useEffect(() => {
    setCount(initialLikes);
  }, [initialLikes]);

  const toggleLike = async (e) => {
    if (e) e.preventDefault();

    const likedPlaces = getLikedPlaces();
    const isLiked = likedPlaces.includes(placeId);
    const newLiked = !isLiked;

    // Optimistic UI update
    setLiked(newLiked);
    setCount((prev) => (newLiked ? prev + 1 : Math.max(0, prev - 1)));

    // Update localStorage
    const updated = newLiked
      ? [...likedPlaces, placeId]
      : likedPlaces.filter((id) => id !== placeId);
    setLikedPlaces(updated);

    // Sync to Firestore
    try {
      await updateDoc(doc(db, "places", placeId), {
        likes: increment(newLiked ? 1 : -1),
      });
    } catch (err) {
      console.error("Error updating likes:", err);
      // Revert on failure
      setLiked(isLiked);
      setCount((prev) => (newLiked ? Math.max(0, prev - 1) : prev + 1));
      setLikedPlaces(likedPlaces);
    }
  };

  return { liked, count, toggleLike };
}
